import React from "react";
import { SITE } from "@/data/site";
import { czk, getBundle } from "@/lib/price";

export const STATUS = {
  new: { label: "Nová", cls: "text-brand-accent border-brand-accent/50" },
  confirmed: { label: "Potvrzená", cls: "text-sky-300 border-sky-300/50" },
  done: { label: "Hotovo", cls: "text-white border-white/40" },
  cancelled: { label: "Zrušená", cls: "text-red-400 border-red-400/50" },
};

const locName = (k) => SITE.locations.find((l) => l.key === k)?.name.replace("Praha ", "") || k;

function Extras({ r }) {
  const bundles = (r.bundles || []).map(getBundle).filter(Boolean);
  const addons = (r.addons || []).map((k) => SITE.addons.find((a) => a.key === k)).filter(Boolean);
  if (!bundles.length && !addons.length && !r.surcharge_price) return <span className="text-brand-muted">—</span>;
  return (
    <div className="flex flex-wrap gap-1">
      {bundles.map((b) => (
        <span key={b.key} className="text-[11px] px-2 py-0.5 bg-brand-accent text-black font-semibold">{b.label}</span>
      ))}
      {addons.map((a) => (
        <span key={a.key} className="text-[11px] px-2 py-0.5 border border-brand-border text-white/90">{a.label}</span>
      ))}
      {r.vehicle_size === "suv" && (
        <span className="text-[11px] px-2 py-0.5 border border-white/40 text-white">SUV +{r.surcharge_pct} %</span>
      )}
    </div>
  );
}

export function ReservationsTable({ items, onStatus }) {
  return (
    <div className="bg-brand-surface border border-brand-border overflow-x-auto" data-testid="admin-reservations-table">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-[10px] uppercase tracking-[0.2em] text-brand-muted border-b border-brand-border">
            <th className="text-left font-medium px-4 py-3">Přijato</th>
            <th className="text-left font-medium px-4 py-3">Zákazník</th>
            <th className="text-left font-medium px-4 py-3">Pobočka</th>
            <th className="text-left font-medium px-4 py-3">Doplňky</th>
            <th className="text-right font-medium px-4 py-3">Cena</th>
            <th className="text-left font-medium px-4 py-3">Stav</th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 && (
            <tr>
              <td colSpan={6} className="px-4 py-10 text-center text-brand-muted">Žádné rezervace.</td>
            </tr>
          )}
          {items.map((r) => (
            <tr key={r.id} data-testid={`reservation-row-${r.id}`} className="border-b border-brand-border/60 last:border-0 hover:bg-white/[0.02]">
              <td className="px-4 py-3 whitespace-nowrap">
                <div className="text-white font-semibold">{new Date(r.created_at).toLocaleDateString("cs-CZ")}</div>
                <div className="text-[11px] text-brand-muted">
                  {new Date(r.created_at).toLocaleTimeString("cs-CZ", { hour: "2-digit", minute: "2-digit" })}
                  {r.date && <> · přání: {r.date}</>}
                </div>
              </td>
              <td className="px-4 py-3">
                <div className="text-white font-semibold">{r.name}</div>
                <div className="text-[11px] text-brand-muted">
                  <a href={`tel:${r.phone}`} className="hover:text-brand-accent">{r.phone}</a>
                  {r.email && <> · {r.email}</>}
                  {r.car && <> · {r.car}</>}
                </div>
                {r.note && <div className="text-[11px] text-white/60 mt-0.5 italic">„{r.note}“</div>}
              </td>
              <td className="px-4 py-3 whitespace-nowrap text-white/90">{locName(r.location)}</td>
              <td className="px-4 py-3 max-w-[280px]"><Extras r={r} /></td>
              <td className="px-4 py-3 text-right whitespace-nowrap font-display font-black text-brand-accent" data-testid={`reservation-total-${r.id}`}>
                {czk(r.total_price)}
                {r.status === "done" && <div className="text-[10px] font-body font-normal text-brand-muted">uhrazeno {czk(r.paid_amount || 0)}</div>}
                {r.member_id && <div className="text-[10px] font-body font-normal text-brand-accent">člen klubu</div>}
              </td>
              <td className="px-4 py-3">
                <select
                  value={r.status}
                  onChange={(e) => onStatus(r.id, e.target.value)}
                  data-testid={`reservation-status-${r.id}`}
                  className={`bg-brand-bg border text-xs px-2 py-1.5 focus:outline-none focus:ring-1 focus:ring-brand-accent ${STATUS[r.status]?.cls || "text-white border-brand-border"}`}
                >
                  {Object.entries(STATUS).map(([k, v]) => (
                    <option key={k} value={k} className="text-white">{v.label}</option>
                  ))}
                </select>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
